import { memo } from 'react';
import { Handle, Position } from 'react-flow-renderer';
import { getSubcontractorStatusMeta } from '../../../../../mock/subcontractors';

const handleStyle = {
    width: 8,
    height: 8,
    minWidth: 8,
    minHeight: 8,
    background: 'transparent',
    border: 'none',
    opacity: 0,
};

const statusClassMap = {
    verified: 'carrier-guard-subcontractor-node--verified',
    verifying: 'carrier-guard-subcontractor-node--verifying',
    unknown: 'carrier-guard-subcontractor-node--unknown',
};

const SubcontractorNode = ({ data }) => {
    if (data.nodeKind === 'root') {
        return (
            <div className="carrier-guard-subcontractor-node carrier-guard-subcontractor-node--root">
                <div className="carrier-guard-subcontractor-node__root-icon">
                    <i className="ri-building-2-line" />
                </div>
                <div className="carrier-guard-subcontractor-node__text">
                    <div className="carrier-guard-subcontractor-node__name">
                        {data.name}
                    </div>
                    <div className="carrier-guard-subcontractor-node__meta">
                        {data.subtitle}
                    </div>
                </div>
                <Handle
                    type="source"
                    position={Position.Bottom}
                    style={handleStyle}
                />
            </div>
        );
    }

    const statusMeta = getSubcontractorStatusMeta(data.status);
    const statusClass = statusClassMap[data.status] || statusClassMap.unknown;

    return (
        <div className={`carrier-guard-subcontractor-node carrier-guard-subcontractor-node--carrier ${statusClass}`}>
            <div className="carrier-guard-subcontractor-node__carrier-icon">
                <i className="ri-truck-line" />
            </div>
            <div className="carrier-guard-subcontractor-node__text">
                <div className="carrier-guard-subcontractor-node__name">
                    {data.name}
                </div>
                <div className="carrier-guard-subcontractor-node__status">
                    <i className={statusMeta.icon} />
                    <span>{statusMeta.title}</span>
                </div>
                <div className="carrier-guard-subcontractor-node__shipments">
                    {data.shipments} shipments
                </div>
            </div>
            <Handle
                type="target"
                position={Position.Top}
                style={handleStyle}
            />
            {!data.isLeaf && (
                <Handle
                    type="source"
                    position={Position.Bottom}
                    style={handleStyle}
                />
            )}
        </div>
    );
};

export default memo(SubcontractorNode);
